import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { UserSettingsFacade } from '@firebird-web/user-settings-store';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'firebird-web-responsiveness',
  templateUrl: './responsiveness.component.html',
  styleUrls: ['./responsiveness.component.scss'],
  standalone: false,
})
export class ResponsivenessComponent implements OnInit, OnDestroy {
  responsivenessFormGroup = this.formBuilder.group({
    responsiveness: true,
  });

  private destroy$ = new Subject<void>();

  constructor(
    private formBuilder: FormBuilder,
    private readonly userSettings: UserSettingsFacade
  ) {}

  public ngOnInit(): void {
    this.userSettings.selectedResponsiveness$
      .pipe(takeUntil(this.destroy$))
      .subscribe((responsiveness) => {
        this.responsivenessFormGroup.setValue({ responsiveness });
      });
  }

  handleChange(type: string): void {
    const value = this.responsivenessFormGroup.get(type)?.value;
    if (value === null || value === undefined) {
      return;
    }

    if (type === 'responsiveness') {
      this.userSettings.changeResponsiveness(value);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
